import { useState, useEffect } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay } from 'swiper/modules'
import Banner from '../../components/Banner'
import Image1 from '../../assets/rooms/room-1.webp'
import Image2 from '../../assets/rooms/room-2.webp'
import Image3 from '../../assets/rooms/room-3.webp'
import Image4 from '../../assets/rooms/room-4.webp'
import Image5 from '../../assets/rooms/room-5.webp'
import Image6 from '../../assets/rooms/room-6.webp'
import Image7 from '../../assets/rooms/room-7.webp'
import Image8 from '../../assets/rooms/room-8.webp'
import { Helmet } from 'react-helmet'
import CapacityIcon from '../../assets/icons/CapacityIcon'
import ChairIcon from '../../assets/icons/ChairIcon'
import ComputerIcon from '../../assets/icons/ComputerIcon'
import TreeIcon from '../../assets/icons/TreeIcon'
import HomeIcon from '../../assets/icons/HomeIcon'
import CTA from '../../components/CTA'
import RoomsAlertModal from '../../components/modals/RoomsAlertModal'

const ITEMS = [
  {
    title: 'Capacidad: (En sede Fader y sede Wast)',
    description: 'Contamos con cuatro salas de reuniones con comodidades para 4 hasta 15 personas.',
    icon: <CapacityIcon width={40} height={40} className="text-orange" />
  },
  {
    title: 'Confort & Tecnología:',
    description: 'Equipadas con TV HDMI, pizarra, climatización y acceso a cocinas e infusiones.',
    icon: <ComputerIcon width={40} height={40} className="text-orange" />
  },
  {
    title: 'Ambiente Profesional:',
    description: 'Un entorno pensado para reuniones efectivas y enfocadas.',
    icon: <ChairIcon width={40} height={40} className="text-orange" />
  }
]

const ROOMS = [
  {
    title: 'Sala alma',
    description: 'Capacidad para 16 personas. ',
    headquarter: 'Wast',
    image: Image1
  },
  {
    title: 'Sala armonía',
    description: 'Capacidad para 6 personas.',
    headquarter: 'Wast',
    image: Image2
  },
  {
    title: 'Sala sol',
    description: 'Capacidad para 6 personas.',
    headquarter: 'Wast',
    image: Image3
  },
  {
    title: 'Sala luna',
    description: 'Capacidad para 6 personas.',
    headquarter: 'Wast',
    image: Image4
  },
  {
    title: 'Sala cosmos',
    description: 'Capacidad  para 4 personas.',
    headquarter: 'Fader',
    image: Image5
  },
  {
    title: 'Sala río',
    description: 'Capacidad para 5 personas.',
    headquarter: 'Fader',
    image: Image6
  },
  {
    title: 'Sala cielo',
    description: 'Capacidad para 6 personas.',
    headquarter: 'Fader',
    image: Image7
  },
  {
    title: 'Sala bosque',
    description: 'Capacidad para 16 personas.',
    headquarter: 'Fader',
    image: Image8
  }
]

const SERVICES = [
  {
    title: 'Conectividad & Tecnología:',
    description:
      'WiFi de alta velocidad con respaldo de emergencia para garantizar continuidad y eficiencia en tu trabajo.',
    image: <ComputerIcon width={40} height={40} className="text-orange" />
  },
  {
    title: 'Comunidad Vida:',
    description:
      'Experiencias mensuales, networking y una red de beneficios exclusivos con marcas y emprendedores locales.',
    image: <CapacityIcon width={40} height={40} className="text-orange" />
  },
  {
    title: 'Espacios Verdes:',
    description:
      '500 m² diseñados para fomentar la creatividad y el bienestar, con áreas de trabajo al aire libre y espacios para reuniones en un entorno natural.',
    image: <TreeIcon width={40} height={40} className="text-orange" />
  },
  {
    title: 'Market Vida:',
    description:
      'Un espacio de autoservicio con productos seleccionados para acompañar tu jornada y potenciar tu energía',
    image: <HomeIcon width={40} height={40} className="text-orange" />
  }
]

const Rooms = () => {
  const [showModal, setShowModal] = useState(false)

  useEffect(() => {
    setTimeout(() => {
      setShowModal(true)
    }, 100)
  }, [])

  return (
    <>
      <Helmet>
        <title>Vida Cowork: Salas de Reuniones</title>
      </Helmet>
      <main className="Rooms">
        <Banner
          title="Salas de reuniones"
          description="Donde las ideas toman forma, los equipos crecen y los proyectos evolucionan"
          message="¡Hola! Quisiera reservar una sala de reunión en Vida"
          whatsappIconLeft
          contact='5493513525163'
        />

        <section className="Rooms__Info container-custom">
          <div className="d-flex flex-column gap-3">
            <p className="text-3 fw-medium text-green">
              ¿Por qué elegir una sala de reunión en vida?
            </p>

            <p className="text-4">
              Diseñamos espacios donde la sinergia impulsa los proyectos. Nuestras salas, totalmente
              equipadas, están pensadas para optimizar el trabajo en equipo, generar ideas y mejorar
              la productividad en un entorno inspirador. En Vida, cada detalle está diseñado para
              que te concentres en lo que realmente importa: hacer crecer tus ideas.
            </p>
          </div>

          <div className="d-flex flex-column justify-content-between align-items-center gap-4">
            {ITEMS.map((item, index) => (
              <div key={`Office-Item-${index}`} className="Rooms__Info-Item">
                {item.icon}
                <div className="d-flex flex-column gap-2">
                  <p className="text-3 fw-medium text-orange">{item.title}</p>
                  <p className="text-4">{item.description}</p>
                </div>
              </div>
            ))}
          </div>
        </section>

        <section className="Rooms__Cards container-fluid">
          <div className="Rooms__Cards-Tramas"></div>

          <div className="Rooms__Cards-Content container-custom">
            <p className="caption text-white fw-medium z-1 text-center">
              Nuestras salas están equipadas para que vos y tu equipo trabajen con comodidad.
            </p>

            <div className="Rooms__Cards-Items d-none d-md-block">
              <Swiper
                className="Rooms__Cards-Swiper"
                modules={[Autoplay]}
                slidesPerView={2}
                spaceBetween={16}
                autoplay={{
                  delay: 5000,
                  disableOnInteraction: false
                }}
                loop
                speed={1500}
                breakpoints={{
                  992: {
                    slidesPerView: 3,
                    spaceBetween: 24
                  },
                  1200: {
                    slidesPerView: 4,
                    spaceBetween: 32
                  }
                }}
              >
                {ROOMS.map((service, index) => (
                  <SwiperSlide key={`Office-Service-${index}`}>
                    <div className="Rooms__Cards-Item">
                      <img
                        className="Rooms__Cards-Image"
                        src={service.image}
                        alt={service.title}
                        title={service.title}
                      />

                      <div className="Rooms__Cards-Text">
                        <div className={`Rooms__Cards-Tag--${service.headquarter} text-5`}>
                          Sede {service.headquarter}
                        </div>

                        <p className="text-2 fw-bold text-green">{service.title}</p>

                        <p className="text-5">{service.description}</p>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>

            <div className="Rooms__Cards-Items d-flex d-md-none">
              {ROOMS.map((service, index) => (
                <div key={`Office-Service-Mobile-${index}`} className="Rooms__Cards-Item">
                  <img
                    className="Rooms__Cards-Image"
                    src={service.image || '/placeholder.svg'}
                    alt={service.title}
                    title={service.title}
                  />

                  <div className="Rooms__Cards-Text">
                    <div className={`Rooms__Cards-Tag--${service.headquarter} text-5`}>
                      {service.headquarter}
                    </div>

                    <div className={`Rooms__Cards-Tag--${service.headquarter} text-5`}>
                      {service.headquarter}
                    </div>

                    <p className="text-2 fw-bold text-green">{service.title}</p>

                    <p className="text-5">{service.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="Rooms__Services container-custom">
          <p className="caption text-green text-center">Servicios que incluye el espacio</p>

          <div className="Rooms__Services-Items">
            {SERVICES.map((service, index) => (
              <div key={`Rooms-Service-${index}`} className="Rooms__Services-Item">
                {service.image}

                <div className="Rooms__Services-Text">
                  <p className="text-3 fw-medium text-orange">{service.title}</p>

                  <p className="text-5">{service.description}</p>
                </div>
              </div>
            ))}
          </div>
        </section>

        <CTA
          title={
            <div className='d-flex flex-column gap-2 title text-green'>
              ¡VIDALIZATE!
              <p
                style={{
                  color: '#616161',
                  fontSize: '24px'
                }}
              > Descubrí cómo nuestras oficinas pueden transformar tu manera de trabajar</p>
            </div>
          }
          cta="¡Haz clic acá para reservar tu oficina ya!"
          message="¡Hola! Quisiera reservar una sala de reunión en Vida"
          imageBanner
          whatsappIconLeft
          contact='5493513525163'
        />
      </main>

      {showModal && <RoomsAlertModal closeModal={() => setShowModal(false)} />}
    </>
  )
}

export default Rooms
